import { TTableColumn } from '../../components/blocks/FnDataTable/types';
import { TTableData } from './types';

export enum ColorgateConfigurationFields {
  MediaName = 'mediaName',
  InkName = 'inkName',
  MetamodeName = 'metamodeName',
  SpecialColorsWhite = 'specialColorsWhite',
  WhiteMinimum = 'whiteMinimum',
  WhiteLimit = 'whiteLimit',
  WhiteIntensity = 'whiteIntensity',
  WhiteSpreadChoke = 'whiteSpreadChoke',
  WhiteEdges = 'whiteEdges',
  SpecialColorsWhite2 = 'specialColorsWhite2',
  PrintSetup = 'printSetup',
  PalletSize = 'palletSize',
  SprayAmount = 'sprayAmount',
  PrintHeight = 'printHeight',
  MediaThickness = 'mediaThickness',
  DefaultSize = 'defaultSize',
  ProportionalSize = 'proportionalSize',
  ProportionalHeight = 'proportionalHeight',
  ProportionalWidth = 'proportionalWidth',
  Rotation = 'rotation',
  OffsetLeft = 'offsetLeft',
  OffsetTop = 'offsetTop',
  ColorCorrection = 'colorCorrection',
  SaturationEnhancement = 'saturationEnhancement'

  /*  BlankModified = 'blankModified',
  DecorationModified = 'decorationModified'*/
}

export const COLORGATE_CONFIGURATION_TITLES = {
  mediaName: 'Media Name / Media',
  inkName: 'Ink Name / Ink',
  metamodeName: 'Metamode Name / Metamode',
  specialColorsWhite: 'White',
  specialColorsWhite2: 'White2 (Highlight)',
  whiteMinimum: 'Minimum',
  whiteLimit: 'Limit',
  whiteIntensity: 'Intensity',
  whiteSpreadChoke: 'Spread (+) / Choke (-)',
  whiteEdges: 'Graded Edges',
  printSetup: 'Printer Setup',
  palletSize: 'Pallet Size / Media Size',
  sprayAmount: 'Spray Amount / Spray Amount',
  printHeight: 'Print height',
  mediaThickness: 'Media thickness',
  defaultSize: 'Default Size Full / Scale 1:1',
  proportionalSize: 'Proportional',
  proportionalHeight: 'Height',
  proportionalWidth: 'Width',
  rotation: 'Rotation',
  offsetLeft: 'Offset Left / Offset x',
  offsetTop: 'Offset Top / Offset y',
  colorCorrection: 'Color correction',
  saturationEnhancement: 'Saturation Enhancement'
};

export const TABLE_COLUMNS: TTableColumn<TTableData>[] = [
  {
    Header: 'Field',
    accessor: 'field',
    width: 360
  },
  {
    Header: 'Value',
    accessor: 'value'
  }
];

export enum RadioValues {
  Yes = 'Yes',
  No = 'No'
}

export const RADIO_OPTIONS = [
  { name: RadioValues.Yes, value: RadioValues.Yes },
  { name: RadioValues.No, value: RadioValues.No }
];

export enum WhiteOptionValues {
  Off = 'Off',
  Brightness = 'Brightness',
  BrightnessBlackSubstrate = 'Brightness - Black Substrate'
}

export const WHITE_OPTIONS = [
  { name: WhiteOptionValues.Off, value: WhiteOptionValues.Off },
  { name: WhiteOptionValues.Brightness, value: WhiteOptionValues.Brightness },
  { name: WhiteOptionValues.BrightnessBlackSubstrate, value: WhiteOptionValues.BrightnessBlackSubstrate }
];

export enum WhiteEdges {
  Zero = '0',
  One = '1',
  Two = '2'
}

export const WHITE_EDGES_OPTIONS = [
  { name: WhiteEdges.Zero, value: WhiteEdges.Zero },
  { name: WhiteEdges.One, value: WhiteEdges.One },
  { name: WhiteEdges.Two, value: WhiteEdges.Two }
];

export enum ConfigurationChanges {
  Blank = 'blank',
  Artwork = 'artwork'
}

export const BLANK_FIELDS: string[] = [
  ColorgateConfigurationFields.MediaName,
  ColorgateConfigurationFields.InkName,
  ColorgateConfigurationFields.MetamodeName,
  ColorgateConfigurationFields.SpecialColorsWhite,
  ColorgateConfigurationFields.WhiteMinimum,
  ColorgateConfigurationFields.WhiteLimit,
  ColorgateConfigurationFields.WhiteIntensity,
  ColorgateConfigurationFields.WhiteSpreadChoke,
  ColorgateConfigurationFields.WhiteEdges,
  ColorgateConfigurationFields.SpecialColorsWhite2,
  ColorgateConfigurationFields.PrintSetup,
  ColorgateConfigurationFields.PalletSize,
  ColorgateConfigurationFields.SprayAmount,
  ColorgateConfigurationFields.PrintHeight,
  ColorgateConfigurationFields.MediaThickness
];

export const WHITE_FIELDS: string[] = [
  ColorgateConfigurationFields.WhiteMinimum,
  ColorgateConfigurationFields.WhiteLimit,
  ColorgateConfigurationFields.WhiteIntensity,
  ColorgateConfigurationFields.WhiteSpreadChoke,
  ColorgateConfigurationFields.WhiteEdges
];

export const PERCENTAGE_SIGN_FIELDS: string[] = [
  ColorgateConfigurationFields.ColorCorrection,
  ColorgateConfigurationFields.SprayAmount
];

export const CENTIMETER_SIGN_FIELDS: string[] = [
  ColorgateConfigurationFields.PrintHeight,
  ColorgateConfigurationFields.ProportionalHeight,
  ColorgateConfigurationFields.ProportionalWidth,
  ColorgateConfigurationFields.OffsetLeft,
  ColorgateConfigurationFields.OffsetTop
];

export enum Units {
  Percentage = '%',
  Centimeter = 'cm'
}

export enum SpecialValues {
  Mode = 'Mode',
  Intensity = 'Intensity',
  Limit = 'Limit',
  SpreadChoke = 'SpreadChoke',
  Edges = 'Edges',
  Minimum = 'Minimum'
}

export const COLOR_BLACK = 'black';
